import React, { createContext, useContext, useState } from "react";
import { abortUpload } from "../service/uploadService";

const UploadContext = createContext(null);

export const UploadProvider = ({ children }) => {
    const [uploads, setUploads] = useState({});

    const addUpload = (id, data) => {
        setUploads((prev) => ({
            ...prev,
            [id]: {
                id,
                progress: 0,
                status: "uploading",
                ...data,
            },
        }));
    };

    const updateUpload = (id, updates) => {
        setUploads((prev) => {
            if (!prev[id]) return prev;
            return {
                ...prev,
                [id]: { ...prev[id], ...updates },
            };
        });
    };

    const removeUpload = (id) => {
        setUploads((prev) => {
            const next = { ...prev };
            delete next[id];
            return next;
        });
    };

    const cancelUpload = async (id) => {
        // Since the uploadService currently uses a global activeUpload, 
        // we can only abort the single active one if it matches the current id.
        // If we want multiple concurrent uploads with individual cancellation, 
        // the uploadService would need to store controllers per ID.
        // For now, we'll follow the existing single-active pattern.
        await abortUpload();
        removeUpload(id);
    };

    return (
        <UploadContext.Provider
            value={{
                uploads,
                addUpload,
                updateUpload,
                removeUpload,
                cancelUpload,
            }}
        >
            {children}
        </UploadContext.Provider>
    );
};

export const useUpload = () => {
    const ctx = useContext(UploadContext);
    if (!ctx) {
        throw new Error("useUpload must be used inside UploadProvider");
    }
    return ctx;
};
